import { ApolloLink, DefaultContext, Operation } from '@apollo/client';
import { COOKIE_KEY, HTTP_HEADERS } from '@shared/constants';
import { setDeviceId } from '@shared/hooks/use-deviceId';
import Cookies from 'js-cookie';

export function createHeaders() {
  const headers: Record<PropertyKey, string> = {};
  const deviceId = Cookies.get(COOKIE_KEY.deviceId) ?? '';
  const authorization = Cookies.get(COOKIE_KEY.accessToken) ?? '';
  const workspaceSecret = Cookies.get(COOKIE_KEY.workspaceSecret) ?? '';
  const locale = Cookies.get(COOKIE_KEY.locale) ?? 'en';

  if (authorization) headers[HTTP_HEADERS.AUTHORIZATION] = authorization;
  if (workspaceSecret) headers[HTTP_HEADERS.WORKSPACE_SECRET] = workspaceSecret;
  if (locale) headers[HTTP_HEADERS.LOCALE] = locale;

  if (deviceId) {
    headers[HTTP_HEADERS.DEVICE_ID] = deviceId;
  } else {
    setDeviceId();
    const newDeviceId = Cookies.get(COOKIE_KEY.deviceId) + '';
    headers[HTTP_HEADERS.DEVICE_ID] = newDeviceId;
  }

  return headers;
}

export function setHeaders(operation: Operation) {
  operation.setContext(({ headers }: DefaultContext) => ({
    headers: { ...headers, ...createHeaders() },
  }));
}

export const authLink = new ApolloLink((operation, forward) => {
  setHeaders(operation);
  return forward(operation);
});
